import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const justifyContentClassNameMap = {
  start: 'tw-justify-start',
  center: 'tw-justify-center',
  end: 'tw-justify-end',
};

export default function TableCell({
  children,
  isFixedHeight = true,
  justifyContent,
  onClick,
  style,
}) {
  return (
    <td className='tw-border-grey-100' onClick={onClick} style={style}>
      <div
        className={classNames(
          'tw-flex',
          isFixedHeight ? 'tw-h-8' : 'tw-min-h-8',
          'tw-items-center',
          justifyContentClassNameMap[justifyContent],
        )}
      >
        {children}
      </div>
    </td>
  );
}

TableCell.propTypes = {
  children: PropTypes.node.isRequired,
  isFixedHeight: PropTypes.bool,
  justifyContent: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

TableCell.defaultProps = {
  justifyContent: 'start',
};
